import { useLocation } from 'react-router';
import { PravoEuFilter } from '../../../model/PravoEuFilter';
import { mapSearchText } from '../../../function/mapSearchText';
import stringToDate from '../../../function/stringToDate';
import useValidPolozkyCiselnik from '../../NavrhAktuEuList/hooks/useValidPolozkyCiselnik';
import { toKodArray } from '../../../function/toKodArray';

interface PravoEuFilterInitData {
  initialFilterLoading: boolean;
  initialFilter: PravoEuFilter;
}

export default (): PravoEuFilterInitData => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const autorKodArray = toKodArray(searchParams.get('autor'));
  const typeKodArray = toKodArray(searchParams.get('type'));
  const polozkyKody = [...autorKodArray, ...typeKodArray];

  const {
    polozkyCiselnik,
    polozkyCiselnikStatus,
  } = useValidPolozkyCiselnik([], [], true, polozkyKody, polozkyKody.length > 0);

  return {
    initialFilter: polozkyCiselnik ? {
      hladanyVyraz: mapSearchText(searchParams.get('hladanyVyraz')),
      celex: mapSearchText(searchParams.get('celex')),
      rokUverejnenia: stringToNumber(searchParams.get('rokUverejnenia')),
      eurovoc: mapSearchText(searchParams.get('eurovoc')),
      type: polozkyCiselnik.find(polozka => typeKodArray.includes(polozka.kod)),
      autor: polozkyCiselnik.find(polozka => autorKodArray.includes(polozka.kod)),
      zmluva: mapSearchText(searchParams.get('zmluva')),
      datumUverejneniaOd: stringToDate(searchParams.get('datumUverejneniaOd')),
      datumUverejneniaDo: stringToDate(searchParams.get('datumUverejneniaDo')),
      datumSchvaleniaOd: stringToDate(searchParams.get('datumSchvaleniaOd')),
      datumSchvaleniaDo: stringToDate(searchParams.get('datumSchvaleniaDo')),
      datumUcinnostiOdOd: stringToDate(searchParams.get('datumUcinnostiOdOd')),
      datumUcinnostiOdDo: stringToDate(searchParams.get('datumUcinnostiOdDo')),
      datumUcinnostiDoOd: stringToDate(searchParams.get('datumUcinnostiDoOd')),
      datumUcinnostiDoDo: stringToDate(searchParams.get('datumUcinnostiDoDo')),
      datumUzavierkyOd: stringToDate(searchParams.get('datumUzavierkyOd')),
      datumUzavierkyDo: stringToDate(searchParams.get('datumUzavierkyDo')),
      datumTranspozicieOd: stringToDate(searchParams.get('datumTranspozicieOd')),
      datumTranspozicieDo: stringToDate(searchParams.get('datumTranspozicieDo')),
    } : undefined,
    initialFilterLoading: polozkyCiselnikStatus.loading,
  };
};

function stringToNumber(input: string): number {
  const parsed = parseInt(input, 10);
  return Number.isNaN(parsed) ? undefined : parsed;
}
